/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CommissionDto} from "./commissionDto.zod";
import {ContactDto} from "./contactDto.zod";
import {NoteDto} from "./noteDto.zod";
import {RegisteredCompanyDto} from "./registeredCompanyDto.zod";
import {RepresentativeContractDto} from "./representativeContractDto.zod";
import {RepresentativeState} from "./representativeState.zod";

export const RepresentativeDto = zod.object({
  representativeId: zod.uuid(),
  state: RepresentativeState,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  deletedAt: zod.iso.datetime({offset: true}).nullable(),
  company: RegisteredCompanyDto,
  logoUrl: zod.string().nullable(),
  exclusive: zod.boolean(),
  currentContract: RepresentativeContractDto,
  contacts: zod.array(ContactDto),
  notes: zod.array(NoteDto),
  commissions: zod.array(CommissionDto),
});

export type RepresentativeDto = zod.input<typeof RepresentativeDto>;
export type RepresentativeDtoOutput = zod.output<typeof RepresentativeDto>;
